import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-creamAlt" data-id="element-70" data-mp="4uqdmw6js2tb">
      <div className="max-w-2xl mx-auto text-center" data-id="element-71" data-mp="4xck0shpcc9y">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-6" data-id="element-72" data-mp="9u37i0vu6a5e">
          <ShieldCheckIcon className="w-8 h-8 text-brand-greenDark" aria-hidden="true" data-id="element-73" data-mp="eu8tb0ffd2fk" />
        </div>

        <h2 className="text-2xl md:text-3xl font-black text-brand-text mb-6 uppercase tracking-wide" data-id="element-74" data-mp="jqptwu3t999j">
          Recuperá tus domingos o te devolvemos la plata
        </h2>

        <p className="text-brand-gray mb-6 leading-relaxed" data-id="element-75" data-mp="sldyei1kamxa">
          7 días de garantía. Si abrís el pack y sentís que no te resuelve el
          año de clases, escribinos y te devolvemos el 100%. Sin formularios y
          sin preguntas.
        </p>

        <a href="#faq" className="text-sm font-bold text-brand-text underline underline-offset-4 transition-colors duration-150 ease-smooth hover:text-brand-greenDeep" data-id="element-76" data-mp="17hlh1dxbngag">
          Política de reembolso completa
        </a>
      </div>
    </section>;
}